export function renderBuildGroupCreatableSelectStateStaticOptionsTemplate({
  fieldName,
  fieldPascal,
  singular,
  schemaName,
  staticOptions
}: {
  fieldName: string
  fieldPascal: string
  singular: string
  schemaName: string
  staticOptions: string
}): string {
  return `  const [${fieldName}Open, set${fieldPascal}Open] = React.useState(false)
  const [${fieldName}Search, set${fieldPascal}Search] = React.useState('')
  const [create${fieldPascal}OptionPending, startCreate${fieldPascal}OptionTransition] = React.useTransition()
  const { data: ${fieldName}CreatedOptions = [] as ${singular}SelectOption[] } = useQuery<${singular}SelectOption[]>({
    queryKey: ['${schemaName}', 'select-options', '${fieldName}'],
    queryFn: () => get${singular}SelectOptions('${fieldName}')
  })
  const ${fieldName}StaticOptions: Array<{ label: string; value: string }> = [${staticOptions}]
  const ${fieldName}Options = [
    ...${fieldName}StaticOptions,
    ...${fieldName}CreatedOptions.filter(
      (createdOption: ${singular}SelectOption) =>
        !${fieldName}StaticOptions.some((option) => option.value === createdOption.value)
    )
  ]`
}
